import { Link } from "react-router-dom";
import { movieCategories } from "@/mocks/movies";

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-line text-background-50 text-lg"></i>
              </div>
              <span className="text-lg font-heading font-bold text-foreground-950">
                天堂影视
              </span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed">
              高清蓝光画质，不缓冲不卡顿，
              <br />
              每日更新电影资源，
              <br />
              免广告畅享观影体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              电影分类
            </h4>
            <div className="space-y-2">
              {movieCategories.slice(0, 5).map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="block text-sm text-foreground-500 hover:text-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              更多分类
            </h4>
            <div className="space-y-2">
              {movieCategories.slice(5).map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="block text-sm text-foreground-500 hover:text-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              关于我们
            </h4>
            <div className="space-y-2">
              <Link
                to="/about"
                className="block text-sm text-foreground-500 hover:text-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                品牌介绍
              </Link>
              <Link
                to="/about"
                className="block text-sm text-foreground-500 hover:text-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                用户口碑
              </Link>
              <Link
                to="/about"
                className="block text-sm text-foreground-500 hover:text-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                联系我们
              </Link>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; 2026 天堂影视 - 版权所有 | 电影大全免费在线观看
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-foreground-400 whitespace-nowrap">
              每日更新 · 高清蓝光 · 免广告
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}